<template>
    <q-layout view="lhr lpr lfr">
        <q-header elevated>
            <gfk-header :title="siteTitle" :subtitle="siteSubtitle">
                <template #right-top>
                    <router-link :to="{name:'caseidStart'}">Home</router-link> |
                    Logged in as <strong>{{ userDisplayName }}</strong> |
                    <router-link :to="{name: 'logout'}">Log out</router-link>
                </template>
                <template #customer-logo>
                    <div  class="customer-logo" style="width:25em; font-family:monospace; color:#fff !important" >
                        <q-input label-color="white" filled inverted readonly v-model="activeCaseId" @click="$event.target.select()" label="Case Id" class="gfk-bg-primary gfk-q-input" ></q-input>
                    </div>
                </template>
            </gfk-header>
        </q-header>
        <q-page-container>
            <q-page>
                <div class="row xs-gutter">
                    <div class="col-lg-12" style="width: 100%;">
                        <q-card class="bg-white no-margin justify-center">
                            <q-card-section>
                                <div class="row items-center sm-gutter justify-center">
                                    <div style="width:50%" >
                                        <q-banner icon="info" class="gfk-bg-info text-white q-alert shadow-2 text-white gfk-banner">
                                            <template v-slot:avatar>
                                                <q-icon name="info" color="white" size="1.5rem" />
                                            </template>
                                            Search criteria: <criteria-list :criteria="criteria"/>
                                        </q-banner>
                                        <q-banner type="positive" class="text-white bg-gold gfk-banner" dismissible style="margin-top:20px;">
                                            <template v-slot:avatar>
                                                <q-icon name="check_circle" color="white" size="1.5rem" />
                                            </template>
                                            Searching all systems can take a while. It's still possible to cancel a search when you have noticed a mistake.
                                        </q-banner>
                                        <q-list class="q-list-search-overview" separated style="margin-top:20px">
                                            <q-item-label header>Searching systems</q-item-label>
                                            <q-item inset>
                                                <q-item-section class="text-primary">Search Status</q-item-section>
                                                <q-item-section>{{ searchProgress.status }}</q-item-section>
                                            </q-item>
                                            <q-item inset>
                                                <q-item-section class="text-primary">Locations searched</q-item-section>
                                                <q-item-section v-if="searchProgress.progress">{{searchProgress.progress.complete}} / {{searchProgress.progress.total}}</q-item-section>
                                            </q-item>
                                            <q-item inset v-if="searchProgress.progress && searchProgress.progress.errorCount > 0">
                                                <q-item-section class="text-red">Location errors</q-item-section>
                                                <q-item-section>{{searchProgress.progress.errorCount}}</q-item-section>
                                            </q-item>
                                        </q-list>
                                        <!--
                                        <div class="row no-wrap" v-for="system in systemProgress">
                                            <div class="col-lg-2">{{system.progress}}%</div>
                                            <div class="col-lg-4">{{system.name}}</div>
                                            <div clas="col-lg-6">{{system.records}} record(s) found</div>
                                        </div>
                                        -->
                                        <div class="row no-wrap" style="margin-top:20px">
                                            <q-btn  style="width: 250px" v-if="!['done', 'limit-reached'].includes(searchProgress.status)" @click="opened=true">Cancel</q-btn>
                                            <q-btn  style="width: 250px" color="blue-10" class="bg-primary text-white"  @click="recordSelection" v-if="['done', 'limit-reached'].includes(searchProgress.status)">Next</q-btn>
                                        </div>
                                    </div>
                                </div>
                            </q-card-section>
                        </q-card>
                    </div>
                </div>
            </q-page>
        </q-page-container>
        <!-- <q-dialog v-model="opened">
            <h6>Are you sure you want to cancel?</h6>
            <div>All search results will be discarded. Once discarded, you will have to do the search again</div>
            <q-btn label="Go back" class="IDback" @click="opened=false" />
            <q-btn label="Discard results" class="IDdiscard" @click="cancelSearch" />
        </q-dialog> -->
        <template>
            <div class="q-gutter-sm">
                <q-dialog v-model="opened">
                    <q-card>
                        <q-card-section class="test">
                            <h6>Are you sure you want to cancel?</h6>
                            <div>All search results will be discarded. Once discarded, you will have to do the search again</div>       
                            <q-btn label="Go back" class="IDback" @click="opened=false" />
                            <q-btn label="Discard results" class="IDdiscard q-ma-md" @click="cancelSearch" />
                        </q-card-section>
                    </q-card>
                </q-dialog>
            </div>
        </template>

        <q-footer class="q-layout-footer">
            <gfk-footer/>
        </q-footer>
    </q-layout>
</template>

<script>
    import {
        QLayout, QToolbar, QSelect, QInnerLoading, QSpinnerGears, QCard, QCardSection, QBtn, QDialog, QList, QItemLabel, QItem, QBanner, QItemSection, QInput, QHeader, QPageContainer, QFooter, QIcon, QPage
    } from 'quasar';

    import authenticateApi from '../api/auth';
    import store from '../store';
    import {
        SEARCH_CRITERIA,
        CASEID,
        CURRENT_SEARCH,
        // SET_ACTIVE_SEARCH_ID,
        LOAD_SEARCH_RESULTS,
        ACTIVE_SEARCH_ID,
        CANCEL_SEARCH
    } from '../store/keys';

    import gfkHeader from './gfk-header.vue';
    import gfkFooter from './gfk-footer.vue';
    import siteData from '../mixins/site-data-mixin';
    import CriteriaList from './criteria-list.vue';

    export default {
        mixins: [siteData],
        components: {
            CriteriaList,
            QLayout,
            QToolbar,
            gfkHeader,
            gfkFooter,
            QSelect,
            QInnerLoading,
            QSpinnerGears,
            QCard,
            QCardSection,
            QBtn,
            QDialog,
            QList,
            QItemLabel,
            QItem,
            QBanner,
            QItemSection,
            QInput,
            QHeader,
            QPageContainer,
            QFooter,
            QIcon,
            QPage
        },
        props: {
            presetId: {
                type: String
            }
        },
        data() {
            return {
                opened: false
            };
        },
        computed: {
            userDisplayName() {
                return authenticateApi.getUsername();
            },
            activeCaseId() {
                return store.getters[CASEID];
            },
            criteria() {
                return store.getters[SEARCH_CRITERIA];
            },
            searchComplete() {
                return _.every(this.systemProgress, (system) => system.progress === 100);
            },
            searchProgress() {
                return store.getters[CURRENT_SEARCH];
            }
        },
        methods: {
            cancelSearch() {
                store.dispatch(CANCEL_SEARCH, store.getters[ACTIVE_SEARCH_ID])
                    .then(() => this.$router.push({name: 'searchStart'}));
            },
            recordSelection() {
                store.dispatch(LOAD_SEARCH_RESULTS).then(() => {
                    this.$router.push({
                        name: 'searchRecordSelection'
                    });
                });
            }
        },
        mounted() {
            // this.searchIntervalID = setInterval(this.updateSearchOverview, 3000);
        }
    };
</script>
